var _style, _path, _defs, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#394D54;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill:#00ACD3;}\r\n\t.st3{fill:#20C2EF;}\r\n\t.st4{stroke:#394D54;stroke-width:0.2881;stroke-miterlimit:10;}\r\n\t.st5{fill:#17B5EB;}\r\n\t.st6{fill-opacity:0.17;}\r\n\t.st7{fill:#D4EDF1;}\r\n\t.st8{fill-opacity:8.500000e-02;}\r\n\t.st9{fill:none;stroke:#394D54;stroke-width:0.6278;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.184659 0 0 .184659 3.070472 31.698131)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,22.2h42.8v43.7h21.6c10,0,20.2-1.8,29.7-5c4.6-1.6,9.9-3.8,14.4-6.5c-6-7.9-9.1-17.8-10-27.6 C470,13.4,472.6-4,481.7-14.4l4.5-5.2l5.4,4.3c13.5,10.8,24.8,26,26.8,43.2c16.2-4.8,35.3-3.6,49.6,4.6l5.9,3.4l-3.1,6 c-12.1,23.6-37.4,31-62.1,29.7c-37,92.2-117.6,135.8-215.3,135.8c-50.5,0-96.8-18.9-123.2-63.7c-1.5-2.8-2.9-5.7-4.3-8.5 c-8.9-19.7-11.9-41.3-9.9-62.9l0.6-6.5h36.6V22.2h42.8v-42.8h85.5v-42.8h51.3V22.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M239-59.6v86h-41.1v43h-34.4l-0.4,3.7c-2.2,23.4,1.9,45,11.3,63.5l3.2,5.7c1.9,3.4,4.1,6.6,6.4,9.7 c2.3,3.1,3.2,4.8,4.6,6.9c24.8,27.9,61.9,41.4,104.6,41.4c94.7,0,175.1-42,210.6-136.2c25.2,2.6,49.4-3.9,60.5-25.4 c-17.6-10.1-40.2-6.9-53.2-0.3l34.5-97.9L411,26.4h-43v-86H239z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -85)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.5,8.9h37.1v37.1h-37.1V8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.5,51.6h37.1v37.1h-37.1V51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "st4",
    d: "M333.1,42.9V12 M338.6,42.9V12 M344.2,42.9V12 M349.9,42.9V12 M355.5,42.9V12 M361,42.9V12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "D_1_",
    className: "st4",
    d: "M333.1,85.6V54.7 M338.6,85.6V54.7 M344.2,85.6V54.7 M349.9,85.6V54.7 M355.5,85.6V54.7  M361,85.6V54.7"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 22.866 4.572651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_1_",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M371.3,88.7h37.1V51.7h-37.1V88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M371.3,45.9h37.1V8.9h-37.1V45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_2_",
    className: "st4",
    d: "M375.8,54.7v30.9 M381.4,54.7v30.9 M387,54.7v30.9 M392.6,54.7v30.9 M398.2,54.7v30.9  M403.8,54.7v30.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "D_3_",
    className: "st4",
    d: "M375.8,12v30.9 M381.4,12v30.9 M387,12v30.9 M392.6,12v30.9 M398.2,12v30.9 M403.8,12v30.9"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "B_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_2_",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157.5,94.4h37.1v37.1h-37.1V94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.5,137.1h37.1v37.1h-37.1V137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_4_",
    className: "st4",
    d: "M162.1,128.4V97.5 M167.6,128.4V97.5 M173.2,128.4V97.5 M178.8,128.4V97.5 M184.5,128.4V97.5  M190,128.4V97.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "D_5_",
    className: "st4",
    d: "M162.1,171.1v-30.9 M167.6,171.1v-30.9 M173.2,171.1v-30.9 M178.8,171.1v-30.9 M184.5,171.1 v-30.9 M190,171.1v-30.9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 22.866 4.572651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_3_",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,174.2h37.1v-37.1h-37.1V174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.3,131.4h37.1V94.4h-37.1V131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_6_",
    className: "st4",
    d: "M204.8,140.2v30.9 M210.4,140.2v30.9 M216,140.2v30.9 M221.6,140.2v30.9 M227.2,140.2v30.9  M232.8,140.2v30.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "D_7_",
    className: "st4",
    d: "M204.8,97.5v30.9 M210.4,97.5v30.9 M216,97.5v30.9 M221.6,97.5v30.9 M227.2,97.5v30.9  M232.8,97.5v30.9"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "B_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_4_",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243,94.4h37.1v37.1H243V94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M243,137.1h37.1v37.1H243V137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_8_",
    className: "st4",
    d: "M247.6,128.4V97.5 M253.1,128.4V97.5 M258.7,128.4V97.5 M264.3,128.4V97.5 M270,128.4V97.5  M275.5,128.4V97.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "D_9_",
    className: "st4",
    d: "M247.6,171.1v-30.9 M253.1,171.1v-30.9 M258.7,171.1v-30.9 M264.3,171.1v-30.9 M270,171.1 v-30.9 M275.5,171.1v-30.9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 22.866 4.572651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_5_",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.8,174.2h37.1v-37.1h-37.1V174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.8,131.4h37.1V94.4h-37.1V131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_10_",
    className: "st4",
    d: "M290.3,140.2v30.9 M295.9,140.2v30.9 M301.5,140.2v30.9 M307.1,140.2v30.9 M312.7,140.2v30.9  M318.3,140.2v30.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "D_11_",
    className: "st4",
    d: "M290.3,97.5v30.9 M295.9,97.5v30.9 M301.5,97.5v30.9 M307.1,97.5v30.9 M312.7,97.5v30.9  M318.3,97.5v30.9"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "B_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_6_",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.5,94.4h37.1v37.1h-37.1V94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.5,137.1h37.1v37.1h-37.1V137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_12_",
    className: "st4",
    d: "M333.1,128.4V97.5 M338.6,128.4V97.5 M344.2,128.4V97.5 M349.9,128.4V97.5 M355.5,128.4V97.5  M361,128.4V97.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "D_13_",
    className: "st4",
    d: "M333.1,171.1v-30.9 M338.6,171.1v-30.9 M344.2,171.1v-30.9 M349.9,171.1v-30.9 M355.5,171.1 v-30.9 M361,171.1v-30.9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 22.866 4.572651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_7_",
    transform: "translate(0 -22.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M371.3,174.2h37.1v-37.1h-37.1V174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M371.3,131.4h37.1V94.4h-37.1V131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_14_",
    className: "st4",
    d: "M375.8,140.2v30.9 M381.4,140.2v30.9 M387,140.2v30.9 M392.6,140.2v30.9 M398.2,140.2v30.9  M403.8,140.2v30.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "D_15_",
    className: "st4",
    d: "M375.8,97.5v30.9 M381.4,97.5v30.9 M387,97.5v30.9 M392.6,97.5v30.9 M398.2,97.5v30.9  M403.8,97.5v30.9"
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M511.2,123.3c2.9-22.3-13.8-39.8-24.1-48.1c-11.9,13.8-13.8,49.9,4.9,65.1c-10.4,9.3-32.4,17.7-54.9,17.7 H160.5c-2.2,23.5,0,136.6,0,136.6h405.7l-1.8-170.9C546.8,113.5,524.2,116.8,511.2,123.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M160.5,188.1v106.6h405.7V188.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.9,285.1c-25.3-12-39.2-28.3-46.9-46.2l-76.9,3.4l39.3,52.4L304.9,285.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M512.9,122.5L512.9,122.5c-39,50.4-94.9,94.3-155,117.3c-53.6,20.6-100.3,20.7-132.5,4.2 c-3.5-2-6.9-4.1-10.3-6.2c-23.6-16.5-36.9-43.8-35.8-79.8h-18.8v136.7h405.7V115.1h-46.7L512.9,122.5z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M182.2,155.5c26.5,1.4,54.7,1.7,79.4-6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M288,136.6c0,5.6-4.6,10.2-10.2,10.2c-5.6,0-10.2-4.6-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2 C283.4,126.4,288,131,288,136.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.4,129.8c-1.4,0.8-1.9,2.7-1.1,4.1c0.5,0.9,1.5,1.5,2.6,1.5c1.1,0,2.1-0.6,2.6-1.6 c0.4,0.9,0.6,1.8,0.6,2.8c0,4-3.3,7.3-7.3,7.3s-7.3-3.3-7.3-7.3c0-4,3.3-7.3,7.3-7.3C278.6,129.3,279.5,129.5,280.4,129.8 L280.4,129.8z M96.9,105.2h475.5c-10.4-2.6-32.8-6.2-29.1-19.7c-18.8,21.8-64.2,15.3-75.7,4.5c-12.8,18.5-87,11.5-92.2-2.9 c-16,18.8-65.6,18.8-81.6,0c-5.2,14.4-79.5,21.5-92.2,2.9c-11.5,10.7-56.8,17.2-75.7-4.5C129.7,99.1,107.3,102.6,96.9,105.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/Docker.6167a32eaa58b444356195b3698934df.svg";
export { ForwardRef as ReactComponent };